import React, { FC, useState, useEffect } from "react";
import moment from "moment";
import firebase from "firebase/app";
import { StyledPaymentHistory } from "..";
import { Table, Spinner } from "../../System";

export type InvoiceType = {
  id: string;
  status_transitions: {
    paid_at: number;
  };
  amount_paid: number;
  hosted_invoice_url: string;
};

const PaymentHistory: FC = () => {
  const listInvoices = firebase.functions().httpsCallable("listInvoices");

  const [errorText, setErrorText] = useState("");
  const [invoices, setInvoices] = useState<InvoiceType[]>([]);
  const [isMoreInvoices, setIsMoreInvoices] = useState(false);

  useEffect(() => {
    listInvoices({ limit: 5 })
      .then((res) => {
        setInvoices(res.data.data);
        setIsMoreInvoices(!!res.data?.has_more);
      })
      .catch((e) => setErrorText(e.message));
  }, []);

  const handleInvoices = async () => {
    if (!isMoreInvoices || !invoices?.length) {
      return;
    }

    const lastInvoiceInList = invoices?.pop();
    const newInvoices = await listInvoices({ after: lastInvoiceInList?.id });
    const newInvoicesData = newInvoices.data?.data;

    setInvoices([...invoices, ...newInvoicesData]);
    setIsMoreInvoices(!!newInvoices.data?.has_more);
  };

  return (
    <StyledPaymentHistory>
      <div className="billing-header">
        <h3 className="billing-subheader">Payment History</h3>
      </div>
      {!invoices.length && <Spinner />}
      {invoices.length > 0 && (
        <div className="payment-history">
          {errorText && <p>{errorText}</p>}
          <Table
            className="payment-history-table"
            headings={["Date", "Receipt", "Price"]}
            rows={invoices.map((invoice) => [
              moment.unix(invoice.status_transitions.paid_at).format("M/D/YY"),
              <a
                href={invoice.hosted_invoice_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Receipt
              </a>,
              `$${(invoice.amount_paid / 100).toFixed(2)}`,
            ])}
          />
          {isMoreInvoices && (
            <div className="load-more-div">
              <button className="billing-button" onClick={handleInvoices}>
                Load More
              </button>
            </div>
          )}
        </div>
      )}
    </StyledPaymentHistory>
  );
};

export default PaymentHistory;
